import React from "react";

import { IconButton, Tooltip } from "@mui/material";
import { formatter } from "../../Modules/Common/commonUtils";

interface IConvenienceFeeProps {
  total: number;
  description: string;
}

export function ConvenienceFee({ total, description }: IConvenienceFeeProps) {
  return (
    <div className="other-charges-item">
      <label>
        Service Fee
      </label>
      <b>
        <Tooltip title={description} placement="top">
          <IconButton sx={{ padding: 0, marginRight: "5px", bottom: "1px" }}>
            <img src="../assets/images/icon-info.svg" className="img-fluid" alt="Delete Item" />
          </IconButton>
        </Tooltip>
        {formatter.format(total)}
      </b>
    </div>
  );
}
